import { Substitutions } from 'features';
import { useAppDispatch, useAppSelector } from 'app/store';
import { uiModel } from 'entities/ui';
import { ComponentModes, RolesUser, SubstitutionsTypes } from 'shared/enums';
import { Division } from 'app/services/edpApiV1/substitutions';
import {
  useGetAllDivisionsQuery,
  useLazyDownloadTimekeeperFileQuery,
} from 'app/services/edpApiV1/substitutions/substitution';
import { divisionsColumns } from 'widgets/substitutions/config';
import { viewerModel } from 'entities/viewer';
import { Button, Table, TableProps } from 'antd';
import { useEffect } from 'react';
import { SorterResult } from 'antd/lib/table/interface';
import { SubstitutionsModel } from 'entities/substitutions';
import { getOrderDivisionsParams, getOrderSupervisorsParams } from 'widgets/substitutions/lib';
import style from './index.module.scss';

const Divisions = () => {
  const dispatch = useAppDispatch();

  const data = useAppSelector(SubstitutionsModel.divisions.selectors.getDivisions);
  const orgId = useAppSelector(viewerModel.me.selectors.getMeOrganizationId);
  const searchParams = useAppSelector(uiModel.Substitutions.selectors.getSearchParams);
  const { page, size } = useAppSelector(uiModel.Substitutions.selectors.getPagination);
  const role = useAppSelector(state => state.entities.viewer.me.role);

  const [downloadTrigger] = useLazyDownloadTimekeeperFileQuery();

  const { isLoading, isFetching, refetch } = useGetAllDivisionsQuery({
    ...searchParams,
    page,
    size,
  });

  const showDrawer = (id: string, orgId: string) => {
    dispatch(
      uiModel.Substitutions.actions.openSubstitutionControlDrawer({
        mode: ComponentModes.edit,
        substitution: { type: SubstitutionsTypes.acting, id },
        orgId,
      }),
    );
  };

  const showDrawerAdd = () => {
    dispatch(
      uiModel.Substitutions.actions.openSubstitutionControlDrawer({
        mode: ComponentModes.add,
        substitution: { type: SubstitutionsTypes.acting },
        orgId,
      }),
    );
  };

  const onChangePage = (value: number, pageSize: number) => {
    dispatch(uiModel.Substitutions.actions.setPagination({ page: value, size: pageSize }));
  };

  const handleTableChange: TableProps<Division>['onChange'] = (pagination, filter, sorter) => {
    if (typeof sorter === 'object') {
      const sort = sorter as SorterResult<Division>;
      if (sort.columnKey === 'name') {
        dispatch(uiModel.Substitutions.actions.setSortByDivision(getOrderDivisionsParams(sort?.order)));
      }
      if (sort.columnKey === 'supervisor') {
        dispatch(uiModel.Substitutions.actions.setSortBySupervisor(getOrderSupervisorsParams(sort?.order)));
      }
    }
  };

  useEffect(() => {
    if (orgId && page > 1) {
      dispatch(uiModel.Substitutions.actions.setPage(1));
    } else refetch();
  }, [orgId]);

  return (
    <div className={style.wrap}>
      <div className={style.header}>
        <Substitutions.Filter />
        <Substitutions.Search />
        <div className={style.actions}>
          <Button onClick={showDrawerAdd} type="primary">
            Добавить замещение
          </Button>
          {(role === RolesUser.HRDirector || role === RolesUser.FirstLine || role === RolesUser.SecondLine) && (
            <Button onClick={() => downloadTrigger()} type="default">
              Выгрузить список табельщиков
            </Button>
          )}
        </div>
      </div>
      <Table
        rowKey={(record, _) => {
          return record?.id + record?.substitution?.id;
        }}
        dataSource={data?.data || []}
        columns={divisionsColumns}
        loading={isFetching || isLoading}
        onRow={(record: Division) => {
          return {
            onClick: () => {
              if (record.substitution) showDrawer(record.substitution.id, record.id);
            },
          };
        }}
        rowClassName={(record: Division) => (record.substitution ? style.row : '')}
        onChange={handleTableChange}
        pagination={{
          defaultCurrent: 1,
          showSizeChanger: true,
          current: page,
          total: data?.pagination.total,
          pageSize: size,
          onChange: onChangePage,
        }}
        scroll={{ x: true }}
      />
    </div>
  );
};

export default Divisions;
